import {
  initialState,
  Actions,
  State,
  DELETE_SESSION_FILE,
  DELETE_SESSION_FILE_SUCCESS,
  DELETE_SESSION_FILE_ERROR,
  RESET_DELETE_SESSION_FILE,
} from "../../types/session/delete-file";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_SESSION_FILE:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_SESSION_FILE_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_SESSION_FILE_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_SESSION_FILE:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducers;
